(function () {
  var THRESHOLD = (window.ZCB_THRESHOLD && parseInt(window.ZCB_THRESHOLD, 10)) || 150000;
  var KOMUR_HANDLE = 'tezyak-tek-kibritle-yanan-dogal-mangal-komur';
  var cachedCart = null;
  var TRUCK = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6h7v9H9z"/><path d="M16 9h3l3 3v3h-6z"/><circle cx="12" cy="17.3" r="1.5"/><circle cx="19" cy="17.3" r="1.5"/></svg>';
  var FALLBACK = [KOMUR_HANDLE, 'askili-kamp-lambasi-gunes-enerjili-type-c-sarjli-led-ampul'];
  var MANGAL_RE = /mangal|izgara|ızgara|güveç|guvec|ateş|ates|ocağ|ocag/;

  function lc(s) { s = s || ''; try { return s.toLocaleLowerCase('tr'); } catch (e) { return s.toLowerCase(); } }
  function money(c) { try { return (c / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL'; } catch (e) { return (c / 100).toFixed(2) + ' TL'; } }
  function isMangalCart(cart) { return cart.items.some(function (i) { if (i.handle === KOMUR_HANDLE) return false; return MANGAL_RE.test(lc(i.product_title || i.title)); }); }

  function shipHTML(cart) {
    var total = cart.total_price, rem = THRESHOLD - total;
    var pct = Math.max(5, Math.min(100, Math.round(total * 100 / THRESHOLD)));
    var done = rem <= 0;
    var msg = done ? 'Tebrikler! <strong>Ücretsiz kargo</strong> kazandınız' : 'Ücretsiz kargoya <strong>' + money(rem) + '</strong> kaldı';
    return '<div class="zcb-ship__msg' + (done ? ' is-done' : '') + '">' + TRUCK + '<span>' + msg + '</span></div>' +
      '<div class="zcb-ship__track"><div class="zcb-ship__fill' + (done ? ' is-done' : '') + '" style="width:' + pct + '%"></div></div>';
  }

  function imgOf(d) { var img = d.featured_image || (d.images && d.images[0]) || ''; if (img && img.indexOf('//') === 0) img = 'https:' + img; return img ? (img.split('?')[0] + '?width=160') : ''; }

  function cardHTML(d) {
    var vid = d.variants && d.variants[0] && d.variants[0].id; if (!vid) return '';
    var imgUrl = imgOf(d);
    return '<div class="zcb-up-card">' +
      '<a class="zcb-up-thumb" href="/products/' + d.handle + '">' + (imgUrl ? '<img src="' + imgUrl + '" alt="" loading="lazy">' : '') + '</a>' +
      '<div class="zcb-up-info"><a class="zcb-up-name" href="/products/' + d.handle + '">' + d.title + '</a><span class="zcb-up-price">' + money(d.price) + '</span></div>' +
      '<button type="button" class="zcb-up-btn" data-vid="' + vid + '">Ekle</button>' +
      '</div>';
  }

  function buildUpsell(up, cart) {
    var inCart = cart.items.map(function (i) { return i.product_id; });
    var inHandles = cart.items.map(function (i) { return i.handle; });
    var firstId = cart.items[0] && cart.items[0].product_id;
    var handles = [];
    if (isMangalCart(cart) && inHandles.indexOf(KOMUR_HANDLE) === -1) handles.push(KOMUR_HANDLE);
    function finish() {
      handles = handles.filter(function (h, i) { return h && handles.indexOf(h) === i; }).slice(0, 2);
      if (!handles.length) { up.innerHTML = ''; return; }
      var out = [], pending = handles.length;
      handles.forEach(function (h, idx) {
        fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
          if (d && inCart.indexOf(d.id) === -1) out[idx] = cardHTML(d);
        }).catch(function () {}).then(function () {
          pending--; if (pending <= 0) { var html = out.filter(Boolean).join(''); up.innerHTML = html ? ('<div class="zcb-up__title">Yanında iyi gider</div><div class="zcb-up__list">' + html + '</div>') : ''; }
        });
      });
    }
    if (firstId) {
      fetch('/recommendations/products.json?product_id=' + firstId + '&intent=related&limit=10').then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
        if (j && j.products) j.products.forEach(function (p) { if (inCart.indexOf(p.id) === -1) handles.push(p.handle); });
        if (!handles.length) handles = FALLBACK.slice();
        finish();
      }).catch(function () { if (!handles.length) handles = FALLBACK.slice(); finish(); });
    } else if (handles.length) { finish(); } else { up.innerHTML = ''; }
  }

  function sigOf(cart) { return cart.item_count + '|' + cart.total_price + '|' + ((cart.items[0] || {}).product_id || ''); }

  function ensureBar(parent, ref, empty, sig) {
    if (!parent) return;
    var bar = parent.querySelector(':scope > .zcb-ship');
    if (!bar) { bar = document.createElement('div'); bar.className = 'zcb-ship'; parent.insertBefore(bar, ref || null); }
    if (empty) { bar.style.display = 'none'; bar.innerHTML = ''; bar.dataset.sig = sig; }
    else { bar.style.display = ''; if (bar.dataset.sig !== sig) { bar.innerHTML = shipHTML(cachedCart); bar.dataset.sig = sig; } }
  }
  function ensureUpsell(parent, ref, empty, sig) {
    if (!parent) return;
    var up = parent.querySelector(':scope > .zcb-upsell');
    if (!up) { up = document.createElement('div'); up.className = 'zcb-upsell'; parent.insertBefore(up, ref || null); }
    if (empty) { up.innerHTML = ''; up.dataset.sig = sig; }
    else if (up.dataset.sig !== sig) { up.dataset.sig = sig; buildUpsell(up, cachedCart); }
  }
  function place() {
    if (!cachedCart) return;
    var sig = sigOf(cachedCart), empty = cachedCart.item_count <= 0;
    // Shrine/Dawn cart DRAWER
    var dFooter = document.querySelector('cart-drawer .drawer__footer, #CartDrawer .drawer__footer');
    if (dFooter) ensureBar(dFooter, dFooter.firstElementChild, empty, sig);
    var dBody = document.querySelector('cart-drawer .cart-drawer__body, #CartDrawer .cart-drawer__body, cart-drawer .drawer__cart-items, cart-drawer .cart-drawer__items');
    if (dBody) ensureUpsell(dBody, null, empty, sig);
    // Shrine/Dawn cart PAGE
    var pFooter = document.querySelector('#MainContent .cart__footer, .cart__footer');
    if (pFooter) { ensureBar(pFooter, pFooter.firstElementChild, empty, sig); ensureUpsell(pFooter, null, empty, sig); }
  }

  function refresh(force) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      cachedCart = c;
      if (force) document.querySelectorAll('.zcb-ship, .zcb-upsell').forEach(function (n) { n.dataset.sig = ''; });
      place();
    }).catch(function () {});
  }

  function onAddClick(e) {
    var btn = e.target.closest ? e.target.closest('.zcb-up-btn') : null; if (!btn) return;
    e.preventDefault();
    var vid = btn.getAttribute('data-vid'); if (!vid || btn.disabled) return;
    btn.disabled = true; btn.textContent = 'Ekleniyor...';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] }) })
      .then(function (r) { return r.json(); }).then(function () { window.location.assign('/cart'); })
      .catch(function () { btn.disabled = false; btn.textContent = 'Ekle'; });
  }

  function init() {
    refresh(true);
    document.addEventListener('cart:update', function () { refresh(true); });
    document.addEventListener('cart:refresh', function () { refresh(true); });
    document.addEventListener('click', onAddClick);
    if ('MutationObserver' in window && document.body) {
      var t; var o = new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { place(); }, 200); });
      o.observe(document.body, { childList: true, subtree: true });
    }
    // periodic safety refresh to catch Dawn section re-renders
    setInterval(function () { refresh(false); }, 4000);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
